import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { RotatingPlaceholder } from '@/src/renderer/components/common/RotatingPlaceholder'
import { useIsActiveTab } from '@/src/renderer/pages/TabStack/ActiveTabContext'
import type { LifeSpace } from '@/src/renderer/lib/db/models'

/** So viele Beispiele stehen je Bereich unter `titleRecognition.placeholders` in den Sprachdateien. */
const EXAMPLE_COUNT = 6

/**
 * **Die wechselnden Beispiele im leeren Titel** (#258) — aus dem Bereich der Seite, hinter dem Feld.
 *
 * Eigenes Innenteil, weil der Tab-Hook hier sitzen muss: `useIsActiveTab()` in `TaskEntry` selbst ließe jede
 * Zeile bei jedem Tab-Wechsel neu rendern. Der Schlüssel erneuert den Durchgang, wenn der Bereich (Ziel-Menü der
 * Schnelleingabe) oder die Sprache wechselt.
 */
export const TitlePlaceholder: React.FC<{ lifeSpace: LifeSpace }> = ({ lifeSpace }) => {
  const { t, i18n } = useTranslation()
  const active = useIsActiveTab()
  const examples = useMemo(
    () => Array.from({ length: EXAMPLE_COUNT }, (_, i) => t(`titleRecognition.placeholders.${lifeSpace}.${i}`)),
    // `t` ist je Sprache ein anderes — beim Wechsel neu lesen.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [lifeSpace, i18n.language],
  )
  return <RotatingPlaceholder key={`${lifeSpace}:${i18n.language}`} className="task-entry__title-placeholder" examples={examples} paused={!active} />
}
